<template>
  <div>
    <vxe-modal
        v-model="salesmanDetailModal"
        title="查看业务员管理"
        width="1200"
        height="660"
        resize
        position="center"
        destroy-on-close
        remember
    >
      <div class="modal-container">
        <div class="add-box clearfix">
          <template>
            <Row style="margin-top: 10px;
    margin-left: 15px;">
              <Col span="4">
                <label>业务员：</label>
                <span>{{ salesMan }}</span>
              </Col>
              <Col span="4">
                <label>客户经理：</label>
                <span>{{ clientManager }}</span>
              </Col>
              <Col span="4">
                <label>销售经理：</label>
                <span>{{ salesManager }}</span>
              </Col>
              <Col span="4">
                <label>外部销售：</label>
                <span>{{ salesManagerOutside }}</span>
              </Col>
              <Col span="4">
                <label>提成设置：</label>
                <span>{{ cpsType | cpsType }}</span>
              </Col>
            </Row>
            <Row style="margin-top: 10px; margin-left: 15px;">
              <Col span="4">
                <label>提成：</label>
                <span>{{ isCps | isSignRule }}</span>
              </Col>
              <Col span="4">
                <label>内部提成：</label>
                <span v-if="rateCps">{{ rateCps }} %</span>
              </Col>
              <Col span="4">
                <label>外部提成：</label>
                <span v-if="rateCpsOutside">{{ rateCpsOutside }} %</span>
              </Col>
              <Col span="4">
                <label>是否签约：</label>
                <span>{{ isSign | isSignRule }}</span>
              </Col>
              <Col span="8" style="display: flex;align-items: center">
                <label>关联合同：</label>
                <a style="display: flex;align-items: center" @click="showDetail()">{{
                    contractNum ? contractNum : ''
                  }}
                </a>
              </Col>
            </Row>
          </template>

          <Tabs value="name1" @on-click="handleTabClick">
            <TabPane label="费率维护" name="name1">
              <vxe-table
                  ref="xTable"
                  class="table-style"
                  show-overflow
                  max-height="350"
                  :data="tableData"
                  align="center"
              >
                <vxe-table-column title="关联公司" field="compName" width="400px">
                  <template v-slot="{ row }">
                    <span>{{ row.compName }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="rateManage" title="管理费(%)">
                  <template v-slot="{row}">
                    <span>{{ row.rateManage }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="realRateManage" title="实收管理费(%)">
                  <template v-slot="{row}">
                    <span>{{ row.realRateManage }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="rateInterest" title="利率(%)">
                  <template v-slot="{row}">
                    <span>{{ row.rateInterest }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="rateDeduct" title="按价税合计抵扣(%)">
                  <template v-slot="{row}">
                    <span>{{ row.rateDeduct }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="rateDeductManage" title="按增值税税额抵扣(%)">
                  <template v-slot="{row}">
                    <span>{{ row.rateDeductManage }}</span>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </TabPane>
            <TabPane label="关联用户" name="name2">
              <vxe-table
                  ref="xTable"
                  class="table-style"
                  show-overflow
                  max-height="350"
                  :data="userTableData"
                  align="center"
              >
                <vxe-table-column title="用户账号" field="userName">
                  <template v-slot="{ row }">
                    <span>{{ row.userName }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="realName" title="用户姓名">
                  <template v-slot="{row}">
                    <span>{{ row.realName }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="compName" title="企业名称">
                  <template v-slot="{row}">
                    <span>{{ row.compName }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="createUser" title="创建人">
                  <template v-slot="{row}">
                    <span>{{ row.createUser }}</span>
                  </template>
                </vxe-table-column>
                <vxe-table-column field="createTime" title="创建时间">
                  <template v-slot="{row}">
                    <span>{{ row.createTime | timeFormatDate }}</span>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </TabPane>
          </Tabs>
          <div style="display: flex">
            <div class="add-box" style="display: inline-block;width: 50%">
              <vxe-table
                  border
                  show-overflow
                  :auto-resize="true"
                  class="table-upload-style"
                  max-height="120"
                  style="margin-bottom: 15px"
                  :data="credData"

                  :edit-config="{trigger: 'click', mode: 'cell'}"
              >
                <vxe-table-column field="url" title="查看证件">
                  <template v-slot="{row}">
                    <upload-list :isEdit="false" :row="row" :initFileList="credList" :view="'arrange'"></upload-list>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
            <div class="add-box" style="display: inline-block;width: 50%">
              <vxe-table
                  show-overflow
                  :auto-resize="true"
                  class="table-upload-style"
                  max-height="120"
                  :data="fileData"
                  :edit-config="{trigger: 'click', mode: 'cell'}"
              >
                <vxe-table-column field="url" title="查看附件">
                  <template v-slot="{row}">
                    <upload-list :isEdit="false" :row="row" :initFileList="fileList" :view="'arrange'"></upload-list>
                  </template>
                </vxe-table-column>
              </vxe-table>
            </div>
          </div>
        </div>
        <div class="modal-footer add-btn-box">
          <!--        <vxe-button-->
          <!--          status="primary"-->
          <!--          @click="salesmanDetailModal=false"-->
          <!--          style="width:140px;border-radius: 0px;margin-right: 10px;"-->
          <!--        >取 消</vxe-button>-->
          <vxe-button
              type="submit"
              status="primary"
              @click="editSalesman()"
              style="width:140px;border-radius: 0px;"
          >编辑
          </vxe-button>
        </div>
      </div>
    </vxe-modal>
    <create-salesman-modal ref="createSalesman" @createCommit="createCommit"></create-salesman-modal>
    <vxe-modal v-model="createModal" :title="modalTitle" width="1300" height="400" @close="closeCreate" resize
               position="center">
      <create ref="modalCreate"></create>
    </vxe-modal>
    <vxe-modal v-model="detailModal" title="合同详情" width="1000" height="900" position="center"
               resize>
      <contract-detail ref="detailModal" @close="closeDetail"></contract-detail>
    </vxe-modal>
  </div>

</template>

<script>
import $api from "@/apiProvider";
import UploadList from "@/components/common/UploadList";
import CreateSalesmanModal from "@/views/authorization/CreateSalesmanModal";
import Create from "@/components/order2.0/Agreement/CreateModal"
import ContractDetail from "@/views/contracts/contractDetail";

export default {
  components: {
    UploadList,
    CreateSalesmanModal,
    Create,
    ContractDetail
  },
  data() {
    return {
      isShowContract: false,
      tableData: [],
      userTableData: [],
      salesId: null,
      credData: [
        {
          fileUuidList: [],
        },
      ],
      fileData: [
        {
          fileUuidList: [],
        },
      ],
      fileList: [],
      credList: [],
      salesMan: null,
      salesManager: null,
      clientManager: null,
      salesmanDetailModal: false,
      isSign: null,
      contractNum: null,
      contractId: null,
      contractType: null,
      createModal: false,
      detailModal: false,
      modalTitle: '',
      isCps: null,
      rateCps: null,
      rateCpsOutSide: null,
      salesManagerOutside: null,
      cpsType: null
    };
  },
  filters: {
    isSignRule(p) {
      if (p === 1) {
        return "是"
      } else {
        return "否"
      }
    },
    cpsType(val) {
      if (val === 1) {
        return "销项仅统计水运"
      } else if (val === 2) {
        return "销项仅统计汽运"
      } else {
        return ''
      }
    }
  },
  methods: {
    closeCreate() {
      this.$refs.modalCreate.close();
    },
    showDetail() {
      this.modalTitle = "合同详情";
      if (this.contractType === '1') {
        this.createModal = true;
        this.$refs.modalCreate.queryContractDetail(this.contractId);
        this.$refs.modalCreate.showDetail();
        this.$refs.modalCreate.orderShow();
      } else if (this.contractType === '2') {
        this.detailModal = true;
        this.$refs.detailModal.orderOpen(this.contractId, 1);
      } else if (this.contractType === '3') {
        this.detailModal = true;
        this.$refs.detailModal.orderOpen(this.contractId, 2);
      }
    },
    closeDetail() {
      this.detailModal = false;
    },
    // openContract() {
    //   this.isShowContract = true;
    //   this.$refs.agreementModel.init();
    // },
    // chooseAgreement(row) {
    //   this.isShowContract = false;
    //   this.relateContract(row);
    // },
    // async relateContract(row) {
    //   let res = await $api.baseUserSales.request("relateContract", {
    //     contractId: row.id,
    //     contractNum: row.numb,
    //     salesManId: this.salesId
    //   });
    //   if (res.status === 1) {
    //     this.$Message.success("关联成功");
    //     this.getSalesmanDetail(this.salesId);
    //   } else {
    //     this.$XModal.alert({
    //       message: res.message ? res.message : "接口异常",
    //       status: "error",
    //     });
    //   }
    // },
    // editSalesman(row) {
    //   this.getSalesmanDetail(row);
    //   this.editReceivingModal = true;
    // },
    editSalesman() {
      var obj = {
        salesManId: this.salesId,
      };
      this.$refs.createSalesman.editSalesman(obj);
      this.salesmanDetailModal = false;
    },
    createCommit(val) {
      // this.getList();
    },
    handleTabClick(name) {
      if (name == "name1") {
        return;
      }
      if (name == "name2") {
        return;
      }
    },
    async getSalesmanDetail(salesManId) {
      this.salesId = salesManId;
      var self = this
      this.credData = [
        {
          fileUuidList: [],
        },
      ]
      this.fileData = [
        {
          fileUuidList: [],
        },
      ]
      this.fileList = []
      this.credList = []
      var data = {
        id: salesManId,
      };

      let response = await $api.baseUserSales.request("querySalesDetail", data);
      if (response.status == 1) {
        this.salesmanDetailModal = true;
        let res = response.data;
        this.clientManager = res.clientManager;
        this.salesManager = res.salesManager;
        this.salesMan = res.salesMan;
        this.contractNum = res.contractNum;
        this.contractId = res.contractId;
        this.contractType = res.contractType;
        this.tableData = res.rateList;
        this.isSign = res.isSign;
        this.isCps = res.isCps;
        this.rateCps = res.rateCps;
        this.rateCpsOutside = res.rateCpsOutside;
        this.salesManagerOutside = res.salesManagerOutside;
        this.cpsType = res.cpsType;

        this.userTableData = res.clientList;
        if (res.credList != null) {
          res.credList.map((i) => {
            self.credList.push(i);
          });
        }
        if (res.fileList != null) {
          res.fileList.map((i) => {
            self.fileList.push(i);
          });
        }
        this.$forceUpdate()
      } else {
        this.$XModal.alert({
          message: response.message ? response.message : "接口异常",
          status: "error",
        });
      }
    },
  },
};
</script>
<style>
.modal-container {
  position: relative;
  height: 100%;
}

.modal-footer {
  padding: 10px 0 0 0;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: flex-end;
  width: 100%;
  position: absolute;
  bottom: 0;
}
</style>